import * as ko from "knockout";

type ConsoleMethod = keyof Console;

const CONSOLE_METHODS: ConsoleMethod[] = [
    'assert', 'clear', 'count', 'countReset', 'debug', 'dir', 'dirxml', 'error',
    'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'table', 'time',
    'timeEnd', 'timeLog', 'timeStamp', 'trace', 'warn',
];

function shouldUseDebugConsole(flag: KnockoutComputed<boolean> | KnockoutObservable<boolean> | boolean): boolean {
    return typeof flag === 'boolean' ? flag : flag();
}

class DebugConsole implements Console {
    public assert!: Console['assert'];
    public clear!: Console['clear'];
    public count!: Console['count'];
    public countReset!: Console['countReset'];
    public debug!: Console['debug'];
    public dir!: Console['dir'];
    public dirxml!: Console['dirxml'];
    public error!: Console['error'];
    public group!: Console['group'];
    public groupCollapsed!: Console['groupCollapsed'];
    public groupEnd!: Console['groupEnd'];
    public info!: Console['info'];
    public log!: Console['log'];
    public table!: Console['table'];
    public time!: Console['time'];
    public timeEnd!: Console['timeEnd'];
    public timeLog!: Console['timeLog'];
    public timeStamp!: Console['timeStamp'];
    public trace!: Console['trace'];
    public warn!: Console['warn'];

    constructor(private shouldUseConsole: KnockoutComputed<boolean> | KnockoutObservable<boolean> | boolean = false) {
        CONSOLE_METHODS.forEach((key) => {
            (this as unknown as Record<string, (...args: any[]) => void>)[key] = (...args: any[]) => {
                if (shouldUseDebugConsole(this.shouldUseConsole)) {
                    const fn = window.console[key] as (...args: any[]) => void;
                    fn.apply(window.console, args);
                }
            };
        });
    }

    /** Called from main.ts after session store is available. */
    setShouldUseConsole(shouldUseConsole: KnockoutComputed<boolean> | KnockoutObservable<boolean> | boolean): void {
        this.shouldUseConsole = shouldUseConsole;
    }
}

export const _d = new DebugConsole(false);

export function wireDebugConsole(shouldUseConsole: KnockoutComputed<boolean> | KnockoutObservable<boolean> | boolean): void {
    _d.setShouldUseConsole(shouldUseConsole);
}
